import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vShow as _vShow } from "vue"

const _hoisted_1 = {
  style: {"max-width":"200px"},
  class: "d-flex flex-column"
}
const _hoisted_2 = { class: "d-flex flex-column pl-2" }
const _hoisted_3 = { class: "d-flex flex-column" }
const _hoisted_4 = ["aria-label", "onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  class: "text-left",
  style: 'padding:0 0 0 12px; width:32px'
}
const _hoisted_7 = { class: "text-left" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { style: 'padding:0 0 0 12px; width:32px' }
const _hoisted_12 = { class: "text-left" }
const _hoisted_13 = { class: "ml-2" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "text-left" }
const _hoisted_17 = { class: "ml-2" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 0,
  class: "text-center"
}
const _hoisted_21 = {
  key: 1,
  class: "text-center"
}
const _hoisted_22 = { style: {"min-width":"30vw"} }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = { key: 3 }
const _hoisted_29 = { class: "text-center" }
const _hoisted_30 = { class: "text-center pt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_LineChart = _resolveComponent("LineChart")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_slider = _resolveComponent("v-slider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_pie_chart = _resolveComponent("pie-chart")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_date_picker_wrapper = _resolveComponent("v-date-picker-wrapper")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, {
      "no-gutters": "",
      class: "mt-2"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "2",
          class: "pr-2"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (_ctx.allPartitions && _ctx.allPartitions.length > 1)
                ? (_openBlock(), _createBlock(_component_v_select_filled, {
                    key: 0,
                    modelValue: _ctx.selectedPartitionId,
                    "onUpdate:modelValue": [
                      _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedPartitionId) = $event)),
                      _cache[1] || (_cache[1] = ($event: any) => (_ctx.skipDetailQuery = false))
                    ],
                    items: _ctx.allPartitions,
                    "item-value": "id",
                    label: "Partition",
                    outlined: "",
                    density: "compact",
                    "item-title": (item) => item.name
                  }, null, 8, ["modelValue", "items", "item-title"]))
                : _createCommentVNode("", true)
            ]),
            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "d-flex flex-column pl-3" }, [
              _createElementVNode("h4", null, "Solde de début")
            ], -1)),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_radio_group, {
                modelValue: _ctx.balanceComputationMode,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.balanceComputationMode) = $event)),
                inline: "",
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.skipChartQuery = false)),
                color: "primary"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_radio, {
                    label: "Réel",
                    value: "ACTUAL"
                  }),
                  _createVNode(_component_v_radio, {
                    label: "Manuel",
                    value: "MANUAL"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              (_ctx.balanceComputationMode === 'MANUAL')
                ? (_openBlock(), _createBlock(_component_oss_text_field_filled, {
                    key: 0,
                    "hide-details": "",
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.skipChartQuery = false)),
                    modelValue: _ctx.manualStartBalance,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.manualStartBalance) = $event))
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true),
              (_ctx.balanceComputationMode === 'ACTUAL')
                ? (_openBlock(), _createBlock(_component_oss_text_field_filled, {
                    key: 1,
                    "hide-details": "",
                    disabled: "",
                    modelValue: _ctx.startBalance,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.startBalance) = $event))
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "10" }, {
          default: _withCtx(() => [
            (_ctx.chartData)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  style: _normalizeStyle(_ctx.barChartStyle)
                }, [
                  (_openBlock(), _createBlock(_component_LineChart, {
                    data: _ctx.chartData,
                    options: _ctx.options,
                    plugins: _ctx.plugins,
                    height: 200,
                    "onChart:rendered": _ctx.handleChartRender,
                    "onChart:updated": _ctx.handleChartRender,
                    key: _ctx.refreshKey
                  }, null, 8, ["data", "options", "plugins", "onChart:rendered", "onChart:updated"]))
                ], 4))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.showSlider && _ctx.chartData && _ctx.chartData.labels && _ctx.chartData.labels.length)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 0,
          "no-gutters": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "2",
              class: "pr-2"
            }),
            _createVNode(_component_v_col, {
              cols: "10",
              style: _normalizeStyle(_ctx.sliderStyle)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_slider, {
                  modelValue: _ctx.todayMonthIndice,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.todayMonthIndice) = $event)),
                  min: "0",
                  max: _ctx.chartData.labels.length,
                  class: "ma-0",
                  style: _normalizeStyle({ width: `${_ctx.sliderWidth}px` }),
                  disabled: _ctx.disableSlider
                }, null, 8, ["modelValue", "max", "style", "disabled"])
              ]),
              _: 1
            }, 8, ["style"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_row, { "no-gutters": "" }, {
      default: _withCtx(() => [
        (_ctx.detailTable && _ctx.detailTable.length)
          ? (_openBlock(), _createBlock(_component_v_col, {
              key: 0,
              cols: "12",
              class: "mt-2",
              style: _normalizeStyle(
                    'padding-right: ' +
                    (this.tablePaddingRight + this.additionalPaddingRight) +
                    'px;'
                )
            }, {
              default: _withCtx(() => [
                (_ctx.detailTable)
                  ? (_openBlock(), _createBlock(_component_v_data_table, {
                      items: _ctx.detailTable,
                      headers: _ctx.headers,
                      "items-per-page": -1,
                      "hide-default-footer": "",
                      "single-expand": false,
                      "item-key": "name",
                      "show-expand": "",
                      loading: _ctx.cashFlowPlanDetailLoading,
                      key: _ctx.refreshKey,
                      density: "compact",
                      class: "table"
                    }, {
                      headers: _withCtx(({ columns: headers }) => [
                        _createElementVNode("tr", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headers, (header, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                              (!!header.align)
                                ? _withDirectives((_openBlock(), _createElementBlock("th", {
                                    key: 0,
                                    role: "columnheader",
                                    class: _normalizeClass(`text-${header.align}`),
                                    "aria-label": header.title,
                                    scope: "col",
                                    onClick: ($event: any) => (_ctx.onTableHeaderColumnClick(index)),
                                    style: _normalizeStyle(_ctx.headerStyle(index))
                                  }, [
                                    _createElementVNode("span", null, _toDisplayString(header.title), 1)
                                  ], 14, _hoisted_4)), [
                                    [_directive_tooltip, {
                                        text: 'Voir la répartition du mois',
                                        disabled: !_ctx.isMonthColumn(index),
                                    }, "bottom"]
                                  ])
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 256))
                        ])
                      ]),
                      "no-data": _withCtx(() => _cache[24] || (_cache[24] = [
                        _createTextVNode("Aucune données")
                      ])),
                      item: _withCtx((props) => [
                        _createElementVNode("tr", {
                          onClick: ($event: any) => (_ctx.expand(props.item))
                        }, [
                          _createElementVNode("td", _hoisted_6, [
                            (props.item.subRows && props.item.subRows.length)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (props.item.expanded === false)
                                    ? (_openBlock(), _createBlock(_component_v_icon, {
                                        key: 0,
                                        size: "x-small"
                                      }, {
                                        default: _withCtx(() => _cache[25] || (_cache[25] = [
                                          _createTextVNode("$keyboard_arrow_down")
                                        ])),
                                        _: 1
                                      }))
                                    : (_openBlock(), _createBlock(_component_v_icon, {
                                        key: 1,
                                        size: "x-small"
                                      }, {
                                        default: _withCtx(() => _cache[26] || (_cache[26] = [
                                          _createTextVNode("$keyboard_arrow_up")
                                        ])),
                                        _: 1
                                      }))
                                ], 64))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_7, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.getRowName(props.item)), 1)
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.item.cashFlow, (value, mi) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: props.index + '-' + mi,
                              class: _normalizeClass(_ctx.amountClass(props.item, mi)),
                              style: _normalizeStyle(_ctx.amountStyle(props.item, mi)),
                              onClick: _withModifiers(($event: any) => (_ctx.openEditCell(props.item, mi)), ["stop"])
                            }, _toDisplayString(_ctx.getValue(props.item, mi)), 15, _hoisted_8))
                          }), 128)),
                          (_ctx.additionalColCount)
                            ? (_openBlock(), _createElementBlock("td", {
                                key: 0,
                                class: "text-center",
                                style: _normalizeStyle(_ctx.amountStyle(props.item, props.item.cashFlow.length))
                              }, [
                                (_ctx.getBalanceDelta(props.item))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.getBalanceDelta(props.item))), 1))
                                  : (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 1,
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => _cache[27] || (_cache[27] = [
                                        _createTextVNode("$oss-circle-check")
                                      ])),
                                      _: 1
                                    }))
                              ], 4))
                            : _createCommentVNode("", true),
                          (_ctx.additionalColCount)
                            ? (_openBlock(), _createElementBlock("td", {
                                key: 1,
                                class: "text-center",
                                style: _normalizeStyle(_ctx.amountStyle(props.item, props.item.cashFlow.length))
                              }, _toDisplayString(_ctx.newCommonFormatCurrency(props.item.balance)), 5))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_5),
                        (
                                props.item.subRows &&
                                props.item.subRows.length &&
                                props.item.expanded
                            )
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(props.item.subRows, (subRow, index) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: props.index + '-' + subRow.name + '-' + index
                              }, [
                                _createElementVNode("tr", {
                                  onClick: ($event: any) => (_ctx.expand(subRow))
                                }, [
                                  _createElementVNode("td", _hoisted_11, [
                                    (subRow.subRows && subRow.subRows.length)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          (subRow.expanded === false)
                                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                                key: 0,
                                                size: "x-small"
                                              }, {
                                                default: _withCtx(() => _cache[28] || (_cache[28] = [
                                                  _createTextVNode("$keyboard_arrow_down")
                                                ])),
                                                _: 1
                                              }))
                                            : (_openBlock(), _createBlock(_component_v_icon, {
                                                key: 1,
                                                size: "x-small"
                                              }, {
                                                default: _withCtx(() => _cache[29] || (_cache[29] = [
                                                  _createTextVNode("$keyboard_arrow_up")
                                                ])),
                                                _: 1
                                              }))
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("td", _hoisted_12, [
                                    _createElementVNode("strong", _hoisted_13, _toDisplayString(_ctx.getRowName(subRow)), 1)
                                  ]),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subRow.cashFlow, (value, index) => {
                                    return (_openBlock(), _createElementBlock("td", {
                                      key: index,
                                      class: _normalizeClass(_ctx.amountClass(subRow, index)),
                                      style: _normalizeStyle(_ctx.amountStyle(subRow, index)),
                                      onClick: _withModifiers(($event: any) => (_ctx.openEditCell(subRow, index)), ["stop"])
                                    }, _toDisplayString(_ctx.getValue(subRow, index)), 15, _hoisted_14))
                                  }), 128)),
                                  (_ctx.additionalColCount)
                                    ? (_openBlock(), _createElementBlock("td", {
                                        key: 0,
                                        class: "text-center",
                                        style: _normalizeStyle(_ctx.amountStyle(subRow, subRow.cashFlow.length))
                                      }, [
                                        (_ctx.getBalanceDelta(subRow))
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.getBalanceDelta(subRow))), 1))
                                          : (_openBlock(), _createBlock(_component_v_icon, {
                                              key: 1,
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[30] || (_cache[30] = [
                                                _createTextVNode("$oss-circle-check")
                                              ])),
                                              _: 1
                                            }))
                                      ], 4))
                                    : _createCommentVNode("", true),
                                  (_ctx.additionalColCount)
                                    ? (_openBlock(), _createElementBlock("td", {
                                        key: 1,
                                        class: "text-center",
                                        style: _normalizeStyle(_ctx.amountStyle(subRow, subRow.cashFlow.length))
                                      }, _toDisplayString(_ctx.newCommonFormatCurrency(subRow.balance)), 5))
                                    : _createCommentVNode("", true)
                                ], 8, _hoisted_10),
                                (
                                        subRow.subRows && subRow.subRows.length && subRow.expanded
                                    )
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(subRow.subRows, (subSubRow, index2) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        key: 
                                            props.index +
                                            '-' +
                                            subRow.name +
                                            index +
                                            '-' +
                                            subSubRow.name +
                                            '-' +
                                            index2
                                        
                                      }, [
                                        _cache[32] || (_cache[32] = _createElementVNode("td", { style: 'padding:0 0 0 12px; width:32px' }, null, -1)),
                                        _createElementVNode("td", _hoisted_16, [
                                          _createElementVNode("strong", _hoisted_17, _toDisplayString(_ctx.getRowName(subSubRow)), 1)
                                        ]),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subSubRow.cashFlow, (value, index) => {
                                          return (_openBlock(), _createElementBlock("td", {
                                            key: index,
                                            class: _normalizeClass(_ctx.amountClass(subSubRow, index)),
                                            style: _normalizeStyle(_ctx.amountStyle(subSubRow, index)),
                                            onClick: _withModifiers(($event: any) => (_ctx.openEditCell(subSubRow, index)), ["stop"])
                                          }, _toDisplayString(_ctx.getValue(subSubRow, index)), 15, _hoisted_18))
                                        }), 128)),
                                        (_ctx.additionalColCount)
                                          ? (_openBlock(), _createElementBlock("td", {
                                              key: 0,
                                              class: "text-center",
                                              style: _normalizeStyle(
                                                _ctx.amountStyle(subSubRow, subSubRow.cashFlow.length)
                                            )
                                            }, [
                                              (_ctx.getBalanceDelta(subRow))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.getBalanceDelta(subSubRow))), 1))
                                                : (_openBlock(), _createBlock(_component_v_icon, {
                                                    key: 1,
                                                    size: "small"
                                                  }, {
                                                    default: _withCtx(() => _cache[31] || (_cache[31] = [
                                                      _createTextVNode("$oss-circle-check")
                                                    ])),
                                                    _: 1
                                                  }))
                                            ], 4))
                                          : _createCommentVNode("", true),
                                        (_ctx.additionalColCount)
                                          ? (_openBlock(), _createElementBlock("td", {
                                              key: 1,
                                              class: "text-center",
                                              style: _normalizeStyle(
                                                _ctx.amountStyle(
                                                    subSubRow,
                                                    subSubRow.cashFlow.length + 1,
                                                )
                                            )
                                            }, _toDisplayString(_ctx.newCommonFormatCurrency(subSubRow.balance)), 5))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          : _createCommentVNode("", true)
                      ]),
                      "body.append": _withCtx(() => [
                        _createElementVNode("tr", null, [
                          _cache[33] || (_cache[33] = _createElementVNode("td", { style: 'padding:0 0 0 12px; width:32px' }, null, -1)),
                          _cache[34] || (_cache[34] = _createElementVNode("td", { class: "text-left" }, [
                            _createElementVNode("strong", { class: "ml-2" }, "Total")
                          ], -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totals, (value, mi) => {
                            return (_openBlock(), _createElementBlock("td", { key: mi }, _toDisplayString(_ctx.newCommonFormatCurrency(value)), 1))
                          }), 128)),
                          (_ctx.additionalColCount)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_20))
                            : _createCommentVNode("", true),
                          (_ctx.additionalColCount)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_21))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }, 8, ["items", "headers", "loading"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["style"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.showEditCellDialog)
      ? (_openBlock(), _createBlock(_component_oss_dialog, {
          key: 1,
          modelValue: _ctx.showEditCellDialog,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.showEditCellDialog) = $event)),
          title: "Paiement",
          validDisabled: !_ctx.isEditionValid,
          onValid: _cache[12] || (_cache[12] = ($event: any) => (_ctx.saveEditCell())),
          showValid: true,
          "max-width": "30wh"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_v_form, {
                modelValue: _ctx.isEditionValid,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.isEditionValid) = $event))
              }, {
                default: _withCtx(() => [
                  (!_ctx.disableInLateAmountEdition)
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 0,
                        "no-gutters": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Reste à payer : " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.cellToEdit.row.balance - _ctx.totalInLateAmount)), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_oss_text_field_filled, {
                            label: "budgeté",
                            class: "mt-2",
                            autofocus: "",
                            readonly: !!_ctx.inBudgetId,
                            modelValue: _ctx.cellToEdit.budgetAmount,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.cellToEdit.budgetAmount) = $event))
                          }, null, 8, ["readonly", "modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_oss_text_field_filled, {
                            label: "En retard",
                            class: "mt-2",
                            autofocus: "",
                            disabled: _ctx.disableInLateAmountEdition,
                            rules: _ctx.inLateAmountRules,
                            modelValue: _ctx.cellToEdit.inLateAmount,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.cellToEdit.inLateAmount) = $event))
                          }, null, 8, ["disabled", "rules", "modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        class: "d-flex justify-end mt-2"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.ifCellToEditAlreadyModified)
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 0,
                                onClick: _withModifiers(_ctx.resetCustomAmount, ["stop"]),
                                size: "x-small"
                              }, {
                                default: _withCtx(() => _cache[35] || (_cache[35] = [
                                  _createTextVNode(" Réinitialiser la valeur ")
                                ])),
                                _: 1
                              }, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "validDisabled"]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.monthDataSnackbar,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.monthDataSnackbar) = $event)),
      color: "warning",
      "multi-line": ""
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_btn, {
          color: "black",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.monthDataSnackbar = false)),
          variant: "text"
        }, {
          default: _withCtx(() => _cache[36] || (_cache[36] = [
            _createTextVNode(" Fermer ")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_ctx.monthDataSnackbarMsg), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.distributionDialog)
      ? (_openBlock(), _createBlock(_component_oss_dialog, {
          key: 2,
          modelValue: _ctx.distributionDialog,
          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.distributionDialog) = $event)),
          title: `Répartition mensuelle`,
          fullscreen: _ctx.$vuetify.display.mobile
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { "no-gutters": "" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "8",
                  class: "d-flex flex-row justify-start align-center"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Période: " + _toDisplayString(`${_ctx.selectedMonthsInRangeNames[0]} ${
                            _ctx.selectedMonthsInRangeNames.length > 1
                                ? "à " +
                                  _ctx.selectedMonthsInRangeNames[_ctx.selectedMonthsInRangeNames.length - 1]
                                : ""
                        }`) + " ", 1),
                    _withDirectives(_createVNode(_component_v_btn_icon, {
                      icon: "$fa-calendar-alt",
                      size: "small",
                      class: "mx-3",
                      color: "#777",
                      onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.toggleDatePicker = _ctx.toggleDatePicker === 1 ? 0 : 1), ["stop"]))
                    }, null, 512), [
                      [_directive_tooltip, 'Sélectionner une autre période', "top"]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "4",
                  class: "d-flex flex-row justify-end"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn_toggle, {
                      modelValue: _ctx.toggleMonthDataViewType,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.toggleMonthDataViewType) = $event)),
                      rounded: "",
                      mandatory: "",
                      density: "compact"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          disabled: _ctx.toggleDatePicker === 1
                        }, {
                          default: _withCtx(() => _cache[37] || (_cache[37] = [
                            _createTextVNode(" Tableau ")
                          ])),
                          _: 1
                        }, 8, ["disabled"]),
                        _createVNode(_component_v_btn, {
                          disabled: _ctx.toggleDatePicker === 1
                        }, {
                          default: _withCtx(() => _cache[38] || (_cache[38] = [
                            _createTextVNode(" Graphique ")
                          ])),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_window, {
                      modelValue: _ctx.toggleDatePicker,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.toggleDatePicker) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_window_item, { value: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_window, {
                              modelValue: _ctx.toggleMonthDataViewType,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.toggleMonthDataViewType) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_window_item, { value: 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            (_ctx.selectedMonthsRangeData)
                                              ? (_openBlock(), _createBlock(_component_v_table, {
                                                  key: 0,
                                                  "fixed-header": "",
                                                  density: "compact",
                                                  height: "60vh"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("thead", null, [
                                                      (
                                                                _ctx.selectedMonthsRangeData[0]
                                                                    .monthValues.length === 1
                                                            )
                                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_23, _cache[39] || (_cache[39] = [
                                                            _createElementVNode("th", null, "Etiquette", -1),
                                                            _createElementVNode("th", null, "Réel", -1),
                                                            _createElementVNode("th", null, "Répartition", -1),
                                                            _createElementVNode("th", null, "Estimé", -1),
                                                            _createElementVNode("th", null, "Répartition budget", -1),
                                                            _createElementVNode("th", null, "Variation", -1)
                                                          ])))
                                                        : (_openBlock(), _createElementBlock("tr", _hoisted_24, [
                                                            _cache[40] || (_cache[40] = _createElementVNode("th", null, [
                                                              _createElementVNode("strong", null, "Etiquette")
                                                            ], -1)),
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedMonthsInRangeNames, (monthName) => {
                                                              return (_openBlock(), _createElementBlock("th", { key: monthName }, [
                                                                _createElementVNode("strong", null, _toDisplayString(monthName), 1)
                                                              ]))
                                                            }), 128)),
                                                            _cache[41] || (_cache[41] = _createElementVNode("th", null, [
                                                              _createElementVNode("strong", null, "Total")
                                                            ], -1)),
                                                            _cache[42] || (_cache[42] = _createElementVNode("th", null, [
                                                              _createElementVNode("strong", null, "Estimé")
                                                            ], -1))
                                                          ]))
                                                    ]),
                                                    _createElementVNode("tbody", null, [
                                                      (
                                                                _ctx.selectedMonthsRangeData[0]
                                                                    .monthValues.length === 1
                                                            )
                                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.selectedMonthsRangeData, (lineData, lineIndex) => {
                                                            return (_openBlock(), _createElementBlock("tr", { key: lineIndex }, [
                                                              _createElementVNode("td", null, [
                                                                _createElementVNode("strong", null, _toDisplayString(lineData.name), 1)
                                                              ]),
                                                              _createElementVNode("td", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            lineData.monthValues[0]
                                                                                .amount,
                                                                        )), 1),
                                                              (
                                                                        lineData.monthValues[0]
                                                                            .relativeAmountPercent ==
                                                                        null
                                                                    )
                                                                ? (_openBlock(), _createElementBlock("td", _hoisted_25, " - "))
                                                                : (_openBlock(), _createElementBlock("td", _hoisted_26, _toDisplayString(_ctx.roundNumber(
                                                                            lineData.monthValues[0]
                                                                                .relativeAmountPercent,
                                                                        )) + "% ", 1)),
                                                              _createElementVNode("td", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            lineData.monthValues[0]
                                                                                .budgetAmount,
                                                                        )), 1),
                                                              (
                                                                        lineData.monthValues[0]
                                                                            .relativeBudgetPercent ==
                                                                        null
                                                                    )
                                                                ? (_openBlock(), _createElementBlock("td", _hoisted_27, " - "))
                                                                : (_openBlock(), _createElementBlock("td", _hoisted_28, _toDisplayString(_ctx.roundNumber(
                                                                            lineData.monthValues[0]
                                                                                .relativeBudgetPercent,
                                                                        )) + "% ", 1)),
                                                              _createElementVNode("td", {
                                                                class: _normalizeClass({
                                                                        green:
                                                                            lineData.monthValues[0]
                                                                                .diff > 0,
                                                                        'custom-orange':
                                                                            lineData.monthValues[0]
                                                                                .diff < 0,
                                                                    })
                                                              }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            lineData.monthValues[0]
                                                                                .diff,
                                                                        )), 3)
                                                            ]))
                                                          }), 128))
                                                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.selectedMonthsRangeData, (rowData, rowIndex) => {
                                                            return (_openBlock(), _createElementBlock("tr", { key: rowIndex }, [
                                                              _createElementVNode("td", null, [
                                                                _createElementVNode("strong", null, _toDisplayString(rowData.name), 1)
                                                              ]),
                                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rowData.monthValues, (monthData, index) => {
                                                                return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            monthData.amount,
                                                                        )), 1))
                                                              }), 128)),
                                                              _createElementVNode("td", null, [
                                                                _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            _ctx.sumByKey(
                                                                                rowData.monthValues,
                                                                                "amount",
                                                                            ),
                                                                        )), 1)
                                                              ]),
                                                              _createElementVNode("td", null, [
                                                                _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            _ctx.sumByKey(
                                                                                rowData.monthValues,
                                                                                "budgetAmount",
                                                                            ),
                                                                        )), 1)
                                                              ])
                                                            ]))
                                                          }), 128))
                                                    ]),
                                                    _createElementVNode("tfoot", null, [
                                                      (
                                                                _ctx.selectedMonthsRangeData[0]
                                                                    .monthValues.length === 1
                                                            )
                                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.selectedMonthsRangeTotalsData, (lineData, lineIndex) => {
                                                            return (_openBlock(), _createElementBlock("tr", { key: lineIndex }, [
                                                              _createElementVNode("td", null, [
                                                                _createElementVNode("strong", null, _toDisplayString(lineData.name), 1)
                                                              ]),
                                                              _createElementVNode("td", null, [
                                                                _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            lineData.monthValues[0]
                                                                                .amount,
                                                                        )), 1)
                                                              ]),
                                                              _cache[43] || (_cache[43] = _createElementVNode("td", null, "-", -1)),
                                                              _createElementVNode("td", null, [
                                                                _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            lineData.monthValues[0]
                                                                                .budgetAmount,
                                                                        )), 1)
                                                              ]),
                                                              _cache[44] || (_cache[44] = _createElementVNode("td", null, "-", -1)),
                                                              _createElementVNode("td", {
                                                                class: _normalizeClass({
                                                                        green:
                                                                            lineData.monthValues[0]
                                                                                .diff > 0,
                                                                        'custom-orange':
                                                                            lineData.monthValues[0]
                                                                                .diff < 0,
                                                                    })
                                                              }, [
                                                                _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            lineData.monthValues[0]
                                                                                .diff,
                                                                        )), 1)
                                                              ], 2)
                                                            ]))
                                                          }), 128))
                                                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.selectedMonthsRangeTotalsData, (lineData, lineIndex) => {
                                                            return (_openBlock(), _createElementBlock("tr", { key: lineIndex }, [
                                                              _createElementVNode("td", null, [
                                                                _createElementVNode("strong", null, _toDisplayString(lineData.name), 1)
                                                              ]),
                                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lineData.monthValues, (monthData, index) => {
                                                                return (_openBlock(), _createElementBlock("td", { key: index }, [
                                                                  _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            monthData.amount,
                                                                        )), 1)
                                                                ]))
                                                              }), 128)),
                                                              _createElementVNode("td", null, [
                                                                _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            _ctx.sumByKey(
                                                                                lineData.monthValues,
                                                                                "amount",
                                                                            ),
                                                                        )), 1)
                                                              ]),
                                                              _createElementVNode("td", null, [
                                                                _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                            _ctx.sumByKey(
                                                                                lineData.monthValues,
                                                                                "budgetAmount",
                                                                            ),
                                                                        )), 1)
                                                              ])
                                                            ]))
                                                          }), 128))
                                                    ])
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_window_item, { value: 1 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          class: "d-flex"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_switch, {
                                              modelValue: _ctx.pieChartSwitchValue,
                                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.pieChartSwitchValue) = $event)),
                                              label: 'Budget',
                                              class: "ml-auto"
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        (
                                                (!_ctx.selectedMonthsHaveDataFor('amount') &&
                                                    !_ctx.pieChartSwitchValue) ||
                                                (!_ctx.selectedMonthsHaveDataFor('budgetAmount') &&
                                                    _ctx.pieChartSwitchValue)
                                            )
                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                              key: 0,
                                              cols: "12",
                                              style: _normalizeStyle({
                                                minHeight: _ctx.$vuetify.display.mobile
                                                    ? '200px'
                                                    : '300px',
                                            }),
                                              class: "d-flex justify-center align-center"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("span", _hoisted_29, " Pas assez de données pour afficher le graphique de la répartion " + _toDisplayString(_ctx.pieChartSwitchValue ? "budgétaire" : "réelle") + ". ", 1)
                                              ]),
                                              _: 1
                                            }, 8, ["style"]))
                                          : _createCommentVNode("", true),
                                        _withDirectives(_createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            (_openBlock(), _createBlock(_component_pie_chart, {
                                              data: _ctx.selectedMonthsPieChartData,
                                              options: _ctx.pieChartOptions,
                                              height: _ctx.$vuetify.display.mobile ? 200 : 300,
                                              style: {"max-height":"400px"},
                                              key: _ctx.pieChartRefreshKey
                                            }, null, 8, ["data", "options", "height"])),
                                            _createElementVNode("h4", _hoisted_30, _toDisplayString(`Répartition ${
                                                        _ctx.pieChartSwitchValue
                                                            ? "budgétaire"
                                                            : "réelle"
                                                    } mensuelle : ${
                                                        _ctx.selectedMonthsInRangeNames[0]
                                                    } ${
                                                        _ctx.selectedMonthsInRangeNames.length > 1
                                                            ? "à " +
                                                              _ctx.selectedMonthsInRangeNames[
                                                                  _ctx.selectedMonthsInRangeNames.length -
                                                                      1
                                                              ]
                                                            : ""
                                                    }`), 1)
                                          ]),
                                          _: 1
                                        }, 512), [
                                          [_vShow, 
                                                (_ctx.selectedMonthsHaveDataFor('amount') &&
                                                    !_ctx.pieChartSwitchValue) ||
                                                (_ctx.selectedMonthsHaveDataFor('budgetAmount') &&
                                                    _ctx.pieChartSwitchValue)
                                            ]
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_window_item, { value: 1 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, {
                              "no-gutters": "",
                              class: "py-3"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  class: "d-flex justify-center"
                                }, {
                                  default: _withCtx(() => _cache[45] || (_cache[45] = [
                                    _createTextVNode("Sélectionner une période")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  class: "d-flex flex-row justify-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_date_picker_wrapper, {
                                      modelValue: _ctx.selectedMonths,
                                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.selectedMonths) = $event)),
                                      color: "gradient",
                                      "first-day-of-week": "1",
                                      type: "month",
                                      style: {"max-width":"800px"},
                                      scrollable: "",
                                      range: "",
                                      "full-width": "",
                                      "hide-header": "",
                                      landscape: !_ctx.$vuetify.display.mobile,
                                      min: _ctx.minDatePickerValue,
                                      max: _ctx.maxDatePickerValue
                                    }, null, 8, ["modelValue", "landscape", "min", "max"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  class: "pt-3 d-flex justify-end"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                      onClick: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (_ctx.toggleDatePicker = 0), ["stop"])),
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => _cache[46] || (_cache[46] = [
                                        _createElementVNode("span", null, "Valider", -1)
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "fullscreen"]))
      : _createCommentVNode("", true)
  ]))
}